/**
 * WizardLandingState - Decorative empty state shown behind the modal
 * when a user enters the creator wizard with a new draft.
 *
 * Purely visual / decorative, no interactive elements.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import './WizardLandingState.css';

const WizardLandingState: React.FC = () => {
  const { t } = useTranslation(['creator']);

  return (
    <div className="wizard-landing-state">
      <div className="wizard-landing-content">
        {/* Sparkle / wand icon */}
        <div className="wizard-landing-icon" aria-hidden="true">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 3l1.912 5.813a2 2 0 0 0 1.275 1.275L21 12l-5.813 1.912a2 2 0 0 0-1.275 1.275L12 21l-1.912-5.813a2 2 0 0 0-1.275-1.275L3 12l5.813-1.912a2 2 0 0 0 1.275-1.275L12 3z" />
            <path d="M5 3v4" />
            <path d="M3 5h4" />
            <path d="M19 17v4" />
            <path d="M17 19h4" />
          </svg>
        </div>

        <h2 className="wizard-landing-title">
          {t('creator:workflow.resourceModal.landingTitle')}
        </h2>
        <p className="wizard-landing-subtitle">
          {t('creator:workflow.resourceModal.landingSubtitle')}
        </p>
      </div>
    </div>
  );
};

export default WizardLandingState;
